<script>
    import LoaderMixin from '../mixins/loader_mixin';

    export default {
        name: 'skeleton-loader',

        mixins: [
            LoaderMixin
        ],

        props: {
            type: {
                type: String,
                default: 'content',
                validate(value) {
                    switch (value) {
                        case 'content':
                        case 'block':
                        case 'avatar':
                        case 'title':
                            return true;
                        default:
                            return false;
                    }
                }
            },

            height: {
                type: String,
                default: null
            },

            width: {
                type: String,
                default: null
            },

            position: {
                type: String,
                default: 'absolute'
            },

            align: {
                type: String,
                default: null
            }
        },

        computed: {
            classArray() {
                return [
                    'skeleton-loader',
                    `skeleton-loader-${this.type}`
                ]
            },

            styleObj() {
                return {
                    height: this.height,
                    position: this.position,
                    width: this.width
                }
            }
        }
    };
</script>

<template>
    <div v-if="isLoading" :class="classArray" :style="styleObj">
    </div>
</template>
